import {
  Product,
  LoginRequest,
  LoginResponse,
  User,
  Cart,
  CreateCartRequest,
} from '../types/Product';

const BASE = process.env.REACT_APP_API_BASE_URL || 'https://fakestoreapi.com';

async function fetchJSON<T>(path: string, options?: RequestInit): Promise<T> {
  const url = `${BASE.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
  const res = await fetch(url, options);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Request failed ${res.status}: ${text}`);
  }
  return (await res.json()) as T;
}

export async function getProducts(): Promise<Product[]> {
  return fetchJSON<Product[]>('products');
}

export async function getProduct(id: number): Promise<Product> {
  return fetchJSON<Product>(`products/${id}`);
}

export async function getCategories(): Promise<string[]> {
  return fetchJSON<string[]>('products/categories');
}

export async function getProductsByCategory(category: string): Promise<Product[]> {
  return fetchJSON<Product[]>(`products/category/${category}`);
}

// Authentication API functions
export async function login(credentials: LoginRequest): Promise<LoginResponse> {
  return fetchJSON<LoginResponse>('auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(credentials),
  });
}

export async function getUser(id: number, token?: string): Promise<User> {
  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return fetchJSON<User>(`users/${id}`, {
    headers,
  });
}

export async function getUsers(token?: string): Promise<User[]> {
  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return fetchJSON<User[]>('users', {
    headers,
  });
}

// Cart API functions
export async function getCarts(): Promise<Cart[]> {
  return fetchJSON<Cart[]>('carts');
}

export async function getCart(id: number): Promise<Cart> {
  return fetchJSON<Cart>(`carts/${id}`);
}

export async function getUserCarts(userId: number): Promise<Cart[]> {
  return fetchJSON<Cart[]>(`carts/user/${userId}`);
}

export async function createCart(cartData: CreateCartRequest): Promise<Cart> {
  return fetchJSON<Cart>('carts', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(cartData),
  });
}

export async function updateCart(id: number, cartData: CreateCartRequest): Promise<Cart> {
  return fetchJSON<Cart>(`carts/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(cartData),
  });
}

export async function deleteCart(id: number): Promise<Cart> {
  return fetchJSON<Cart>(`carts/${id}`, {
    method: 'DELETE',
  });
}

export default {
  getProducts,
  getProduct,
  getCategories,
  getProductsByCategory,
  login,
  getUser,
  getUsers,
  getCarts,
  getCart,
  getUserCarts,
  createCart,
  updateCart,
  deleteCart,
};
